/**
 * Píxeles de conversión Meta/TikTok (client-side), configurables desde Admin.
 * Los IDs se leen de GET /funnel/pixels/public y los snippets se inyectan
 * dinámicamente. GA4 client-side ya vive en index.html (gtag).
 * pixelTrack() comparte event_id con la CAPI server-side para deduplicar.
 */
import { apiClient } from "@/lib/api";
import { trackEvent } from "@/lib/analytics";

const NAMES = {
  lead: { meta: "Lead", tiktok: "SubmitForm", ga4: "generate_lead" },
  checkout: { meta: "InitiateCheckout", tiktok: "InitiateCheckout", ga4: "begin_checkout" },
  purchase: { meta: "Purchase", tiktok: "CompletePayment", ga4: "purchase" },
};

let initDone = false;

function injectMeta(pixelId) {
  if (window.fbq) return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
}

function injectTikTok(pixelId) {
  if (window.ttq) return;
  /* eslint-disable */
  !(function (w, d, t) {
    w.TiktokAnalyticsObject = t; var ttq = (w[t] = w[t] || []);
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
    ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) { var e = ttq._i[t] || []; for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e; };
    ttq.load = function (e, n) {
      var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = i; ttq._t = ttq._t || {}; ttq._t[e] = +new Date(); ttq._o = ttq._o || {}; ttq._o[e] = n || {};
      var o = d.createElement("script"); o.type = "text/javascript"; o.async = !0; o.src = i + "?sdkid=" + e + "&lib=" + t;
      var a = d.getElementsByTagName("script")[0]; a.parentNode.insertBefore(o, a);
    };
    ttq.load(pixelId); ttq.page();
  })(window, document, "ttq");
  /* eslint-enable */
}

export async function initPixels() {
  if (initDone) return;
  try {
    const { data } = await apiClient.get("/funnel/pixels/public");
    initDone = true;
    if (data?.meta_pixel_id) injectMeta(data.meta_pixel_id);
    if (data?.tiktok_pixel_id) injectTikTok(data.tiktok_pixel_id);
  } catch { /* se reintentará en el próximo initPixels() */ }
}

export function pixelTrack(event, { value, eventId } = {}) {
  const n = NAMES[event];
  if (!n) return;
  const data = value != null ? { value: Number(value), currency: "MXN" } : {};
  try { if (window.fbq) window.fbq("track", n.meta, data, eventId ? { eventID: eventId } : undefined); } catch { /* noop */ }
  try { if (window.ttq) window.ttq.track(n.tiktok, { ...data, event_id: eventId }); } catch { /* noop */ }
  try { trackEvent(n.ga4, { ...data, transaction_id: eventId }); } catch { /* noop */ }
}
